module.exports = __webpack_public_path__ + "img/WieGottInFrankreich.aa6767d8.jpg";